import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { DateTime } from 'luxon';
dayjs.extend(localizedFormat);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);
export const formatDate = (d, options) => new Date(d).toLocaleDateString('en-us', options || { year: 'numeric', month: 'long', day: 'numeric' });
export const formatTime = (d) => dayjs(d).format('LT');
export const currentDateTimeInMs = () => new Date().getTime();
export const currentTimeZone = () => {
    return DateTime.local().offsetNameLong;
};
export const timeZoneAbbr = () => {
    const longName = currentTimeZone();
    return longName
        .split(' ')
        .map((word) => word.charAt(0))
        .join('');
};
export const isTheSameDayFromUTC = (from, to) => {
    try {
        const dateFrom = DateTime.fromISO(from);
        const dateTo = DateTime.fromISO(to);
        return dateFrom.hasSame(dateTo, 'day');
    }
    catch (error) {
        console.log(error);
        return false;
    }
};
export const hasOneDayDuration = (from, to) => {
    try {
        const dateFrom = DateTime.fromISO(from);
        const dateTo = DateTime.fromISO(to);
        const diff = dateTo.diff(dateFrom, 'day').toObject().days;
        return diff <= 1;
    }
    catch (error) {
        console.log(error);
        return false;
    }
};
export const dateIsInFuture = (date) => {
    const currentDate = new Date();
    const givenDate = new Date(date);
    return givenDate > currentDate;
};
